import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

const RmrMerchantMetrics_ = z.object({
  returnRate: z.number().nullable(),
  coveredReturnRate: z.number().nullable(),
  totalInventoryQuantity: z.number(),
  totalInventoryValueCents: z.number(),
  itemsRoutedLast30d: z.number(),
  itemsRoutedValueCents: z.number(),
  itemsReceivedLast30d: z.number(),
  fsrPremiumsCents: z.number(),
  fsrCreditsCents: z.number(),
  refulfillmentRevenueCents: z.number(),
});
export const RmrMerchantMetrics: z.ZodType<RmrMerchantMetrics> =
  RmrMerchantMetrics_;
export interface RmrMerchantMetrics
  extends z.infer<typeof RmrMerchantMetrics_> {}

export const getRmrMerchantMetrics = unaryRpc({
  name: "getRmrMerchantMetrics" as const,
  input: z.object({ teamId: z.string() }),
  output: RmrMerchantMetrics,
});
